import { sliderOperatorByInputOperator, surveysInitialFormValues } from '../constants';
import { getRespondedStatus, getSliderValueFromAttribute } from '../utils';
import { SurveyAttribute, SurveysFormValues } from '../../../types';

export const getSurveysInitialFormValues = (
  surveyItems: SurveyAttribute[],
): SurveysFormValues[] => {
  if (surveyItems.length === 0) {
    return [surveysInitialFormValues];
  }

  return surveyItems.map<SurveysFormValues>((item) => {
    const {
      surveyOperator,
      minAmount,
      maxAmount,
      selectedOptions,
      survey,
      locations,
      locationGroups,
    } = item;

    return {
      survey,
      respondedStatus: getRespondedStatus(item),
      surveyAnswers: selectedOptions || [],
      minValue: minAmount ?? undefined,
      maxValue: maxAmount ?? undefined,
      value: getSliderValueFromAttribute(item),
      sliderOperator: sliderOperatorByInputOperator[surveyOperator] || 'is-equal-to',
      locations: locations || [],
      locationGroups: locationGroups || [],
    };
  });
};
